import moment from 'moment'
import dateTimeStandardMask from 'app/utils/date/dateTimeStandardMask'

import {
    dateTimeMask,
} from 'app/utils/date'

import LoggerAge, {
    LoggerAgeType,
} from './LoggerAge'

type Props = {
    mapCellProps: string,
    rowProps: LoggerAgeType,
}

const LoggerAgeFromDate = ({
    mapCellProps,
    rowProps,
}: Props) => {
    return (
        <LoggerAge
            mapCellProps={mapCellProps}
            rowProps={{
                ...rowProps,
                [mapCellProps]:
                    moment(rowProps[mapCellProps], dateTimeMask).format(dateTimeStandardMask),
            }}
        />
    )
}

export default LoggerAgeFromDate
